// Auto-generate tags from article data (keyword, hub, title)
// This avoids manually tagging 65+ articles

const TAG_KEYWORDS = {
  "nausea": ["nausea", "nauseous", "sick", "vomiting"],
  "constipation": ["constipation", "constipated", "digestive", "digestion", "bowel"],
  "fatigue": ["fatigue", "tired", "energy", "exhausted", "low energy"],
  "weight-loss": ["weight loss", "losing weight", "plateau", "stall", "scale"],
  "protein": ["protein", "muscle", "lean mass"],
  "food": ["eat", "eating", "meal", "food", "snack", "diet"],
  "side-effects": ["side effect", "symptom"],
  "ozempic": ["ozempic", "semaglutide"],
  "mounjaro": ["mounjaro", "tirzepatide"],
  "wegovy": ["wegovy"],
  "injection": ["injection", "inject", "dose", "shot"],
  "sleep": ["sleep", "insomnia", "rest"],
  "anxiety": ["anxiety", "anxious", "mental"],
  "exercise": ["exercise", "workout", "training", "resistance"],
  "hydration": ["hydration", "water", "dehydrated", "fluid"],
  "bloating": ["bloating", "bloat", "gas", "burp"],
  "reflux": ["reflux", "heartburn", "acid"],
  "hair-loss": ["hair loss", "hair"],
  "supplements": ["supplement", "vitamin", "magnesium"],
  "plateau": ["plateau", "stall", "stuck"],
  "motivation": ["motivation", "consistent", "burnout"],
  "binge-eating": ["binge", "emotional eating", "food noise"],
  "diarrhea": ["diarrhea", "loose stool"],
  "muscle-loss": ["muscle loss", "losing muscle", "recomposition"],
  "meal-timing": ["timing", "when to eat", "meal plan", "schedule"],
  "dose-change": ["dose", "increase", "switching", "restart", "missed"],
};

const HUB_TO_TAG = {
  "side-effects": "side-effects",
  "food-protein": "food",
  "expectations": "getting-started",
  "results": "weight-loss",
};

export function generateTags(article) {
  if (!article) return [];
  const tags = new Set();

  const searchText = [
    article.keyword || "",
    article.title || "",
    article.metaDescription || "",
  ].join(" ").toLowerCase();

  // Match against tag keywords
  for (const [tag, keywords] of Object.entries(TAG_KEYWORDS)) {
    for (const kw of keywords) {
      if (searchText.includes(kw)) {
        tags.add(tag);
        break;
      }
    }
  }

  // Add hub-based tag
  if (article.hub && HUB_TO_TAG[article.hub]) {
    tags.add(HUB_TO_TAG[article.hub]);
  }

  return Array.from(tags).slice(0, 5);
}

// Human-readable tag labels
export const TAG_LABELS = {
  "nausea": "Nausea",
  "constipation": "Constipation",
  "fatigue": "Fatigue",
  "weight-loss": "Weight Loss",
  "protein": "Protein",
  "food": "Food & Diet",
  "side-effects": "Side Effects",
  "ozempic": "Ozempic",
  "mounjaro": "Mounjaro",
  "wegovy": "Wegovy",
  "injection": "Injection",
  "sleep": "Sleep",
  "anxiety": "Anxiety",
  "exercise": "Exercise",
  "hydration": "Hydration",
  "bloating": "Bloating & Gas",
  "reflux": "Acid Reflux",
  "hair-loss": "Hair Loss",
  "supplements": "Supplements",
  "plateau": "Plateau",
  "motivation": "Motivation",
  "binge-eating": "Emotional Eating",
  "diarrhea": "Diarrhea",
  "muscle-loss": "Muscle Loss",
  "meal-timing": "Meal Timing",
  "dose-change": "Dose Changes",
  "getting-started": "Getting Started",
};
